import { useQuery } from '@tanstack/vue-query'
import { MaybeRef, toValue } from 'vue'
import { hcaClientFactory } from '@/api/factories/HcaClientFactory'

export const useGeneratorHistoricalQuery = (
    generatorId: MaybeRef<string>,
    analysisType: MaybeRef<number | undefined>,
    measurementType: MaybeRef<number | undefined>,
    languageId: MaybeRef<number>,
    startDate: MaybeRef<string | undefined>,
    endDate: MaybeRef<string | undefined>,
) => {
    return useQuery({
        queryKey: [
            'generators',
            generatorId,
            'historical',
            analysisType,
            measurementType,
            languageId,
            startDate,
            endDate,
        ],
        queryFn: async ({ signal }) => {
            const generatorIdValue = toValue(generatorId)
            const measurementTypeValue = toValue(measurementType)
            const analysisTypeValue = toValue(analysisType)
            
            if (!generatorIdValue || !measurementTypeValue || !analysisTypeValue) {
                return null
            }

            const {
                data: { result },
            } = await hcaClientFactory.componentStatusApi.getGeneratorHistoricalTrends(
                generatorIdValue,
                analysisTypeValue,
                measurementTypeValue,
                toValue(languageId),
                toValue(startDate),
                toValue(endDate),
                { signal }
            )

            return result
        },
    })
}
